<div [class]="wrapper_classes" aria-label="Paginador" tabindex="0" role="menu">
	<app-contained-progress-bar [show]="bLoading"></app-contained-progress-bar>

	<mat-paginator #paginator
		showFirstLastButtons
		[length]="pagination.total"
		[pageSizeOptions]="pageSizeOptions"
		[pageIndex]="pagination.current_page-1"
		[pageSize]="pagination.per_page"
		(page)="onPageChange($event)"
	></mat-paginator>
</div>